import { render, staticRenderFns } from "./LegalDocumentTaskQueue.vue?vue&type=template&id=57212115&scoped=true&"
import script from "./LegalDocumentTaskQueue.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentTaskQueue.vue?vue&type=style&index=0&id=57212115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57212115",
  null
  
)

export default component.exports